// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enUS from "./Locales/en.json";
import esES from "./Locales/esES.json";
import enUK from "./Locales/uk.json";
import fr from "./Locales/frCA.json";
import jaJP from "./Locales/jaJP.json";
import zh from "./Locales/zh.json";
import koKR from "./Locales/koKR.json";
import nl from "./Locales/nl.json";
import de from "./Locales/de.json";
import it from "./Locales/it.json";
import daDK from "./Locales/daDK.json";
import svSE from "./Locales/svSE.json";
import noNO from "./Locales/noNO.json";
import deCH from "./Locales/deCH.json";
import frCH from "./Locales/frCH.json";
import itCH from "./Locales/itCH.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      // AMER
      "en-US": { translation: enUS },
      "fr-CA": { translation: fr },
      //EMEA
      "nl-BE": { translation: nl },
      "fr-BE": { translation: fr },
      "de-CH": { translation: deCH },
      "fr-CH": { translation: frCH },
      "it-CH": { translation: itCH },
      "de-DE": { translation: de },
      "da-DK": { translation: daDK },
      "es-ES": { translation: esES },
      "fr-FR": { translation: fr },
      "en-GB": { translation: enUK },
      "it-IT": { translation: it },
      "nl-NL": { translation: nl },
      "no-NO": { translation: noNO },
      "sv-SE": { translation: svSE },
      "en-GL": { translation: enUK },
      //ASIA
      "en-AU": { translation: enUS },
      "ja-JP": { translation: jaJP },
      "ko-KR": { translation: koKR },
      "en-NZ": { translation: enUS },
      "en-SG": { translation: enUS },
      "en-HK": { translation: enUS },
      "zh-TW": { translation: zh },
      "zh-Hant": { translation: zh },
    },
    fallbackLng: {
      // AMER
      "en-US": ["en-US"],
      "fr-CA": ["fr-CA", "en-US"],

      // EMEA
      "nl-BE": ["nl-BE", "en-GB", "en-US"],
      "fr-BE": ["fr-BE", "en-GB", "en-US"],
      "de-CH": ["de-CH", "en-GB", "en-US"],
      "fr-CH": ["fr-CH", "en-GB", "en-US"],
      "it-CH": ["it-CH", "en-GB", "en-US"],
      "de-DE": ["de-DE", "en-GB", "en-US"],
      "da-DK": ["da-DK", "en-GB", "en-US"],
      "es-ES": ["es-ES", "en-GB", "en-US"],
      "fr-FR": ["fr-FR", "en-GB", "en-US"],
      "en-GB": ["en-GB", "en-US"],
      "it-IT": ["it-IT", "en-GB", "en-US"],
      "nl-NL": ["nl-NL", "en-GB", "en-US"],
      "no-NO": ["no-NO", "en-GB", "en-US"],
      "sv-SE": ["sv-SE", "en-GB", "en-US"],
      "en-GL": ["en-GL", "en-GB", "en-US"],

      // ASIA
      "en-AU": ["en-AU", "en-US"],
      "ja-JP": ["ja-JP", "en-US"],
      "ko-KR": ["ko-KR", "en-US"],
      "en-NZ": ["en-NZ", "en-US"],
      "en-SG": ["en-SG", "en-US"],
      "en-HK": ["en-HK", "en-US"],
      "zh-TW": ["zh-TW", "en-US"],
      "zh-Hant": ["zh-Hant", "en-US"],

      // Default
      default: ["en-US"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
